import React from 'react'
import { CheckboxProps, ThemingProps } from '@chakra-ui/react'
import { Checkbox } from 'front-end/src/components'

export const CheckboxBig = (
  props: CheckboxProps & {
    colorScheme?: ThemingProps['colorScheme']
    isRounded?: boolean
    noIcon?: boolean
  }
) => {
  const { isRounded, noIcon, ...rest } = props
  return (
    <Checkbox
      colorScheme="buttonPrimary"
      data-test="CheckboxBig"
      size="lg"
      variant={isRounded ? 'rounded' : undefined}
      {...rest}
    />
  )
}
